module.exports = __webpack_public_path__ + "static/media/griffith-faculty.508c1cf7.jpg";